import { useTranslation } from 'react-i18next';
import Alert from './Alert';
import { useAlertStore } from './AlertStore';
import { useCallback } from 'react';

export const useNotifyWithParam = () => {
  const { showAlert, hideAlert } = useAlertStore();
  const { t } = useTranslation();

  const notify = useCallback(
    (
      messageKey: string,
      parameterKey: string,
      parameterValue: string,
      onCloseCallback?: () => void
    ) => {
      showAlert({
        content: (
          <Alert
            message={t(messageKey, { [parameterKey]: parameterValue })}
            onClose={() => {
              hideAlert();
              if (onCloseCallback) onCloseCallback();
            }}
          />
        ),
      });
    },
    [showAlert, hideAlert, t]
  );

  return notify;
};
